import { z } from 'zod';
import { zStringRequired } from '../../z';
export const fallAssessmentValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        morseFallHistory: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        morseSecondaryDx: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        morseAmbulatoryAid: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        morseIvTherapy: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        morseGait: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        morseMentalStatus: z
            .number()
            .nullable()
            .default(null)
            .refine((v) => v !== null, { message: 'required' }),
        intrinsicAgeOver65: z.boolean().default(false),
        intrinsicVisualImpairment: z.boolean().default(false),
        intrinsicHearingImpairment: z.boolean().default(false),
        intrinsicCognitiveImpairment: z.boolean().default(false),
        intrinsicIncontinence: z.boolean().default(false),
        intrinsicOrthostatic: z.boolean().default(false),
        intrinsicLowerExtremity: z.boolean().default(false),
        intrinsicBalanceDeficit: z.boolean().default(false),
        intrinsicDizziness: z.boolean().default(false),
        intrinsicPainAffecting: z.boolean().default(false),
        intrinsicDehydration: z.boolean().default(false),
        intrinsicFearOfFalling: z.boolean().default(false),
        extrinsicLooseCarpets: z.boolean().default(false),
        extrinsicPoorLighting: z.boolean().default(false),
        extrinsicClutteredPathway: z.boolean().default(false),
        extrinsicNoGrabBars: z.boolean().default(false),
        extrinsicUnsafeFootwear: z.boolean().default(false),
        extrinsicPetTripping: z.boolean().default(false),
        extrinsicStairsNoRail: z.boolean().default(false),
        extrinsicWetSurfaces: z.boolean().default(false),
        extrinsicHighBed: z.boolean().default(false),
        extrinsicMedicalEquipment: z.boolean().default(false),
        medSedatives: z.boolean().default(false),
        medAntihypertensives: z.boolean().default(false),
        medOpioids: z.boolean().default(false),
        medPsychotropics: z.boolean().default(false),
        medAnticonvulsants: z.boolean().default(false),
        medAnticoagulants: z.boolean().default(false),
        medHypoglycemics: z.boolean().default(false),
        medPolypharmacy: z.boolean().default(false),
        fallsJson: z.string().default('[]'),
        additionalInterventions: z.string().default(''),
        patientGoal: z.string().default(''),
        reassessDate: z.string().default(''),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
